module.exports = __webpack_public_path__ + "static/media/garbage.99595221.svg";